import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import RegisterAgentForm from '../../components/RegisterAgentForm';
import { useNavigate } from 'react-router-dom';
import { getUserFromStorage } from '../../utils/auth';


const AdminAgentRegistrationPage = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
  
    useEffect(() => {
      const storedUser = getUserFromStorage();
      if (storedUser?.role === 'admin' || storedUser?.role === 'agent') {
        setUser(storedUser);
      } else {
        navigate('/login'); // ✅ redirect if not admin
      }
    }, [navigate]);
  
    if (!user) return null;
  
    return (
      <DashboardLayout role="admin">
       <RegisterAgentForm user={user} />
      </DashboardLayout>
    );
  };
  

export default AdminAgentRegistrationPage;
